<template>
  <div id="register">
    <img src="../../assets/img/enroll-water.png" alt="" />
    <div class="right-mes">
      <img class="logo" src="../../assets/img/home-logo.png" alt="" />
      <p class="title">Freshwater algae database</p>
      <el-form
        :model="regForm"
        :rules="rules"
        ref="regForm"
        label-width="32px"
        class="register-form-content"
        hide-required-asterisk
      >
        <el-form-item prop="email">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-mail.png"
              alt=""
              class="email-img"
            />
          </i>
          <el-input
            type="email"
            v-model="regForm.email"
            autocomplete="off"
            placeholder="Please enter your email"
          ></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-name.png"
              alt=""
              class="name-img"
            />
          </i>
          <el-input
            type="text"
            v-model.trim="regForm.name"
            autocomplete="off"
            placeholder="Please enter your name"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contact" :show-message="false">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-phone.png"
              alt=""
              class="phone-img"
            />
          </i>
          <el-input
            type="text"
            v-model.number="regForm.contact"
            autocomplete="off"
            placeholder="Please enter your mobile number"
          ></el-input>
        </el-form-item>
        <el-form-item prop="company" :show-message="false">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-company.png"
              alt=""
              class="company-img"
            />
          </i>
          <el-input
            type="text"
            v-model.trim="regForm.company"
            autocomplete="off"
            placeholder="Please enter company unit"
          ></el-input>
        </el-form-item>
        <p class="has-account">
          <span>Existing account?</span>
          <router-link class="jump-to-log" to="/login">Log in now</router-link>
        </p>
        <el-form-item class="submit-btn">
          <el-button @click="submitForm('regForm')" :disabled="hasSubmit">
            <span v-if="!hasSubmit">register</span>
            <i class="el-icon-loading" v-else></i>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import http from '../../utils/http'
import { Message } from 'element-ui'
import validate from '@/utils/validate'
export default {
  name: 'Register',
  data () {
    const validateRegister = (rule, value, callback) => {
      http.get(`/auditCheckRegister?name=${this.regForm['email']}`, {}, res => {
        if (res.code === 200) {
          callback()
        } else {
          if (res.code === 400) {
            callback(new Error('The mailbox has been registered'))
          } else {
            callback(new Error(`${res.msg}`))
          }
        }
      })
    }
    return {
      hasSubmit: false,
      regForm: {
        email: '',
        name: '',
        contact: '',
        company: ''
      },
      rules: {
        email: [
          { required: true, message: ' ', trigger: 'blur' },
          { type: 'email', message: ' ', trigger: ['blur'] },
          {
            validator: this.$utils.debounce(validateRegister, 500, true),
            trigger: 'blur'
          }
        ],
        name: [
          {
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkUsername(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, trigger: 'blur' }
        ],
        contact: [
          {
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkPhone(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, trigger: 'blur' }
        ],
        company: [{ required: true, trigger: 'blur' }]
      }
    }
  },
  created () {
    this.$store.commit('toTop')
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.hasSubmit = true
          http.post(
            '/auditRegister',
            {
              email: this.regForm['email'],
              name: this.regForm['name'],
              contact: this.regForm['contact'],
              company: this.regForm['company']
            },
            res => {
              if (res.code === 200) {
                this.$router.push('/register/examine')
              } else {
                Message.error(`${res.msg}`)
                this.hasSubmit = false
              }
            }
          )
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#register {
  box-sizing: border-box;
  min-width: vw(1200);
  padding: vw(0) vw(282) vw(0) vw(20);
  display: flex;
  img {
    width: vw(980);
    height: vw(919);
    margin-right: vw(216);
  }
  .right-mes {
    margin-top: vw(160);
    .logo {
      margin-bottom: vw(43);
      width: vw(186);
      height: vw(43);
    }
    .title {
      margin-bottom: vw(60);
      color: #333333;
      font-size: vw(30);
      font-weight: bold;
    }
    .register-form-content {
      .el-form-item {
        border-bottom: 1px solid #dddddd;
        margin: vw(40) 0 0 0;
        >>> .el-form-item__label {
          padding: 0;
          height: 100%;
          .icon-label {
            display: inline-block;
            width: 100%;
            height: 100%;
            position: relative;
            img {
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-75%);
            }
            .email-img {
              width: vw(24);
              height: vw(19);
            }
            .name-img {
              width: vw(25);
              height: vw(26);
            }
            .phone-img {
              width: vw(20);
              height: vw(25);
            }
            .company-img {
              width: vw(24);
              height: vw(24);
            }
          }
        }
        >>> .el-form-item__content {
          .el-input {
            .el-input__inner {
              border: none;
              font-size: vw(16);
              // &::-webkit-input-placeholder {
              //   @include placeholder-font;
              // }
              // &:-moz-placeholder {
              //   @include placeholder-font;
              // }
              // &::-moz-placeholder {
              //   @include placeholder-font;
              // }
              // &:-ms-input-placeholder {
              //   @include placeholder-font;
              // }
            }
          }
          .el-form-item__error {
            padding: vw(4) 0 0 vw(15);
          }
        }
        &.is-error {
          border-bottom: 1px solid red;
        }
      }
      .has-account {
        margin: vw(13) 0 0 0;
        font-size: vw(14);
        color: #999999;
        .jump-to-log {
          color: $theme_color;
          &:hover {
            color: $theme_color_hover;
          }
        }
      }
      .submit-btn {
        border: none;
        margin: vw(80) 0 0 0;
        >>> .el-form-item__content {
          width: 100%;
          margin-left: 0 !important;
          .el-button {
            width: 100%;
            height: vw(60);
            background: $theme_color;
            font-size: vw(22);
            font-weight: 400;
            color: #fbf9fa;
            border-radius: 4px;
            border: none;
            &:focus {
              outline: 0;
            }
            &:hover {
              background: $theme_color_hover;
            }
          }
        }
      }
    }
    // .item-box {
    //   position: relative;
    //   .el-input {
    //     margin-bottom: vw(30);
    //     >>> .el-input__inner {
    //       border: none;
    //       border-bottom: 1px solid #dddddd;
    //       padding-left: vw(40);
    //       font-size: vw(20);
    //       color: #999999;
    //       border-radius: 0;
    //     }
    //   }
    //   img {
    //     position: absolute;
    //     top: 14%;
    //     left: 0;
    //   }
    //   .mail-img {
    //     width: vw(24);
    //     height: vw(19);
    //   }
    //   .name-img {
    //     width: vw(25);
    //     height: vw(26);
    //   }
    //   .phone-img {
    //     width: vw(20);
    //     height: vw(25);
    //   }
    //   .company-img {
    //     width: vw(24);
    //     height: vw(24);
    //   }
    // }
    // .fog-pasw {
    //   font-size: vw(16);
    //   color: #999999;
    //   .register {
    //     color: #333333;
    //     cursor: pointer;
    //     &:hover {
    //       color: $theme_color;
    //     }
    //   }
    //   .fog {
    //     cursor: pointer;
    //     &:hover {
    //       color: $theme_color;
    //     }
    //   }
    // }
    // button {
    //   outline: none;
    //   border: none;
    //   cursor: pointer;
    //   margin-top: vw(80);
    //   width: vw(419);
    //   height: vw(60);
    //   background-color: $theme_color;
    //   border-radius: 4px;
    //   color: #fbf9fa;
    //   font-size: vw(24);
    //   &:hover {
    //     background-color: $theme_color-hover;
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enroll/register.vue